module.exports = __webpack_public_path__ + "static/media/svg_icon-color.554532cc.svg";